import { Channel } from '@domain/eventTeam';

import { ChannelRow } from './channel-row';
import { useTeamChannelContext } from './team-channel-section-context';

interface ChannelSectionProps {
  channel: Channel;
  isMobileViewPort: boolean;
  canCloseSales: boolean;
  labelClassName?: string;
}

export const ChannelSection = ({ channel, isMobileViewPort, canCloseSales, labelClassName }: ChannelSectionProps) => {
  const { getChannelError, updateChannelMax, setChannelSalesClosed } = useTeamChannelContext();

  return (
    <ChannelRow
      channel={channel}
      isMobileViewPort={isMobileViewPort}
      error={getChannelError(channel.channel.id)}
      isNested={false}
      updateChannelMax={updateChannelMax}
      setChannelSalesClosed={setChannelSalesClosed}
      canCloseSales={canCloseSales}
      labelClassName={labelClassName}
    />
  );
};
